<template>
  <div>
    <nav aria-label="breadcrumb" style="border-radius:0;">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link v-bind:to="{'name': $i18n.locale + 'Settings'}">
            {{ $t('settings') }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link v-bind:to="{'name': $i18n.locale + 'ListProperties'}">
            {{ $t('properties') }}
          </router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page" v-if="$route.params.property">{{ $t('property.edit') }}</li>
        <li class="breadcrumb-item active" aria-current="page" v-else>{{ $t('property.create') }}</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <header class="page header">
        <div class="content">
          <h1 class="display-4 mb-0 mt-4">
            <span v-if="$route.params.property">
              {{ $t('property.edit') }}
            </span>
            <span v-else>{{ $t('property.create') }}</span>
          </h1>
          <p class="lead text-muted">
            <span v-if="$route.params.property">
              {{ $t('property.edit') }} {{ $route.params.property }}
            </span>
            <span v-else>{{ $t('property.create') }}</span>
          </p>
        </div>
      </header>
      <div class="content">
        <div class="row">
          <div class="col-md-6 border-right">
            <ValidationObserver v-slot="{ handleSubmit }" ref="form">
              <form id="propertyForm">

                <h5>{{ $t('information.property') }}</h5>

                <Property v-bind.syn="{property: property}"></Property>

                <h5>{{ $t('information.address') }}</h5>
                <Address v-bind.syn="{address: property.address}"></Address>

                <h5>{{ $t('information.contact') }}</h5>
                <Contact v-bind.syn="{property: property}"></Contact>


                <div class="d-flex w-100">

                  <div class="btn-group btn-group-justified d-flex w-100 pb-5 pt-4">
                    <button v-b-modal.confirmDeleteModal type="button" name="delete" class="btn btn-danger flex-grow-1" v-bind:class="{'disabled': !property._id}">{{ $t('delete') }}</button>
                    <button type="button" name="save" class="btn btn-primary flex-grow-1" @click="handleSubmit(submit)">{{ $t('save') }}</button>
                  </div>
                </div>

              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>

    <ConfirmDelete ref="confirmDelete" v-bind.sync="{type: 'property', delete: deleteProperty}"></ConfirmDelete>
  </div>
</template>

<script>

import Property from './components/Property.vue';
import Address from './components/Address.vue';
import Contact from './components/Contact.vue';

import ConfirmDelete from '../partials/modals/ConfirmDelete.vue';


export default {
  name: 'CreateProperty',
  props: ['socket'],
  components: {
    Property, Address, Contact, ConfirmDelete
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(from.name){
        vm.from = from.fullPath
      }
    });
  },
  data: () => ({
    from: null,
    property: {
      "contact": {},
      "address": {},
      "time": {}
    },
  }),
  created(){
    if(this.$route.params.property){
      let property = this.$store.state.host.properties.find(p => p.slug == this.$route.params.property) || {};

      fetch(process.env.VUE_APP_API + '/properties/' + property._id, {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          "CSRF-Token": this.$csrf
        }
      })
      .then(response => {
        return response.json();
      })
      .then(result => {
        console.log("wtf");
        console.log("result")
        this.property = result;
      })
    }
  },
  methods: {
    submit: function(){

      let url = this.property._id ? '/properties/' + this.property._id : '/properties';
      let action = this.property._id ? 'PUT' : 'POST';

      console.log(url);
      console.log(action);

      return fetch( process.env.VUE_APP_API + url, {
        method : action,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'CSRF-Token': this.$csrf
        },
        body: JSON.stringify({
          property: this.property,
          socket: {
            id: this.socket.id
          }
        })
      })
      .then(response => response.json())
      .then(response => {
        if(!response.error){

          console.log("response");
          console.log(response)
          this.$store.dispatch('set')
          .then(() => {
            this.$parent.messages.push({
              type: "alert",
              status: 'success',
              message: 'Property Created Successfully',
              time: Date.now()
            })
            if(this.$store.state.host.properties.length < 2 && !this.property._id){
              this.$router.push({'name': this.$i18n.locale + 'CreateRoom', params: { property: response.slug } });
            }else{
              this.$router.push({'name': this.$i18n.locale + 'ListProperties' });
            }
          });
        }else{
          console.log(response.error);
          this.$refs.form.setErrors(response.error.messages);
        }
      });
    },
    deleteProperty: function(){
      return fetch(process.env.VUE_APP_API + '/properties/' + this.property._id, {
        method: 'delete',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => response.json())
      .then(response => {
        if(!response.error){
          this.$store.dispatch('set')
          .then(() => {
            this.$parent.messages.push({
              type: "alert",
              status: 'success',
              message: 'Property Deleted Successfully',
              time: Date.now()
            })
            this.$router.push({'name': this.$i18n.locale + 'ListProperties'});
          })
        }else{
          this.$parent.messages.push({
            type: "alert",
            status: 'danger',
            message: response.error,
            time: Date.now()
          })
        }
      });
    }
  }
}
</script>

<i18n>
{
  "en": {
    "settings": "Settings",
    "properties": "Properties",
    "property": {
      "create": "Create Property",
      "edit": "Edit Property"
    },
    "information": {
      "property": "Property Information",
      "contact": "Contact Information",
      "address": "Address"
    }
  },
  "sl": {
    "settings": "Nastavitve",
    "properties": "Nastanitve",
    "property": {
      "create": "Ustvari nastanitev",
      "edit": "Uredi nastanitev"
    },
    "information": {
      "property": "Podatki nastanitve",
      "contact": "Kontaktni podatki",
      "address": "Naslov"
    },
    "save": "Shrani",
    "delete": "Pobriši"
  }
}
</i18n>
